import { commonAPI } from '@/services-ts/axios'
import type { IBulkUpdateOrderMenu, IPayloadMenu } from '@/types/Request'
import type { IMenuStore } from '@/types/Store/State'
import { Alert, Format } from '@/utils-ts'
import { defineStore } from 'pinia'

export const useMenuStore = defineStore('menu', {
  state: (): IMenuStore => ({
    menu: [],
  }),

  actions: {
    async GetMenuList(LanguageId: string) {
      const { status, data } = await commonAPI.MenuServices.GetMenuList(LanguageId)
      this.menu = status ? data : []
    },

    async CreateMenu(payload: IPayloadMenu, LanguageId: string) {
      const { status, data } = await commonAPI.MenuServices.CreateMenu(payload)
      if (status) {
        if (this.menu[0]?.languageId === LanguageId) {
          this.menu.push(data)
        }
        void Alert({
          message: Format('admin_components_company_menusettings_menucreated'),
          type: 'success',
        })
      }
      return status
    },

    async UpdateMenu(payload: IPayloadMenu) {
      const { status, data } = await commonAPI.MenuServices.UpdateMenu(payload)
      if (status) {
        if (payload.Id) {
          const index = this.menu.findIndex(item => item.id === payload.Id)
          if (index !== -1) {
            this.menu[index] = data
          }
        } else {
          this.menu.push(data)
        }

        this.menu.sort((a, b) => a.orderId - b.orderId)
        void Alert({ message: Format('admin_global_updated'), type: 'success' })
      }
      return status
    },

    async DeleteMenu(Id: string) {
      const { status } = await commonAPI.MenuServices.DeleteMenu(Id)
      if (status) {
        this.menu = this.menu.filter(item => item.id !== Id)
        void Alert({ message: Format('admin_global_deleted'), type: 'success' })
      }
    },

    async UpdateMenuOrder(data: IBulkUpdateOrderMenu[], languageId: string) {
      const { status } = await commonAPI.MenuServices.BulkUpdateMenuOrder(data)

      if (status) {
        await this.GetMenuList(languageId)
        void Alert({ message: Format('admin_global_updated'), type: 'success' })
      }
    },
  },

  getters: {
    GetLastOrderId(): number {
      const lastOrderId = this.menu.length > 0 ? this.menu[this.menu.length - 1]!.orderId : 0
      return lastOrderId
    },
  },
})
